<ng-container>
  <div class="no-items-display">
    <div class="no-items-header">
      @if (emptyViewSvg()) {
        <xi-svg [svg]="emptyViewSvg()"></xi-svg>
      }
    </div>

    <p class="no-items-title">{{ emptyViewTitle() }}</p>

    <p class="no-items-message">{{ emptyViewText() }}</p>

    @if (showCtaButton()) {
      <xi-default-button
        (onClick)="ctaButtonClick.emit()"
        [text]="ctaButtonText()"
        [disabled]="isCtaBtnDisabled()"
      ></xi-default-button>
    }
  </div>
</ng-container>
